import { useDispatch, useSelector } from "react-redux";
import { getShowRunHistoryPaneState } from "ee/selectors/workflowRunHistorySelectors";
import React from "react";
import { Button, Tooltip } from "@appsmith/ads";
import { toggleRunHistoryPane } from "ee/actions/workflowRunHistoryActions";
import {
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_HIDE_TOOLTIP,
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_LABEL,
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_SHOW_TOOLTIP,
  createMessage,
} from "ee/constants/messages";
import { setJsPaneDebuggerState } from "actions/jsPaneActions";
import { setPluginActionEditorDebuggerState } from "PluginActionEditor/store";

export function RunHistoryTrigger() {
  const dispatch = useDispatch();
  const paneVisible = useSelector(getShowRunHistoryPaneState);

  const onClick = () => {
    dispatch(setJsPaneDebuggerState({ open: false }));
    dispatch(setPluginActionEditorDebuggerState({ open: false }));
    dispatch(toggleRunHistoryPane(!paneVisible));
  };

  const tooltipContent = createMessage(
    !paneVisible
      ? WORKFLOW_RUN_HISTORY_PANE_TRIGGER_SHOW_TOOLTIP
      : WORKFLOW_RUN_HISTORY_PANE_TRIGGER_HIDE_TOOLTIP,
  );

  return (
    <Tooltip content={tooltipContent}>
      <Button
        data-testid="t--workflow-run-history-trigger"
        kind={"tertiary"}
        onClick={onClick}
        size="md"
        startIcon={"history"}
      >
        {createMessage(WORKFLOW_RUN_HISTORY_PANE_TRIGGER_LABEL)}
      </Button>
    </Tooltip>
  );
}
